import React, { useState, useContext, useEffect } from "react";
import Label from "../../elements/Label/Label";
import Image from "../../elements/image/Image";
import Master from "../../utils/Master";
// import axios from "axios";
import axios from "../../api/axios";
import "./iconslist.css";
import { Trash2 } from "lucide-react"; // using lucide-react for delete icon
import { Snackbar, Alert } from "@mui/material";   

const Iconslist = (props) => {
  const [errortext, seterrortext] = useState("");
  const {
    iconlist,
    seticonlist,
    groupicons,
    setgroupicons,
    apicalled,
    setapicalled,
  } = useContext(Master);

  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteIconId, setDeleteIconId] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    sevirity: "success",
  });

  // --- DELETE FUNCTION ---
  const confirmDelete = (id) => {
    setDeleteIconId(id);
    setShowConfirm(true);
  };

  const handleDelete = () => {
    if (!deleteIconId) return;

    axios
      .delete(`icon/${deleteIconId}`)
      .then((response) => {
        if (response.data.success) {
          const newList = iconlist.filter((icon) => icon.id !== deleteIconId);
          seticonlist(newList);
          setSnackbar({
            open: true,
            message: "Icon Deleted Successfully",
            severity: "success"
          })
        }
      })
      .catch((error) => {
        console.error("API call error:", error);
        setSnackbar({
            open: true,
            message: "Icon Delete Failed",
            severity: "error",
        })
      })
      .finally(() => {
        setDeleteIconId(null);
        setShowConfirm(false);
      });
  };

  
  const handleCloseSnackbar = (event, reason) =>{
    if(reason === "clickaway") return;
    setSnackbar({...snackbar, open: false})
  }

  function checkchange(value) {
    // if(groupicons.length<=10){
    var groupiconscopy = [...groupicons];

    if (groupiconscopy.indexOf(value + "") == -1) {
      if (groupiconscopy.length < 10) {
        groupiconscopy.push(value + "");
      }
    } else {
      groupiconscopy.splice(groupiconscopy.indexOf(value + ""), 1);
    }
    setgroupicons(groupiconscopy);
    // }
  }

  useEffect(() => {
    axios
      .get("icon")
      .then((response) => {
        seticonlist(response.data);
      })
      .catch((error) => {
        console.error("API call error:", error);
      });
  }, [apicalled]);

  return (
    <div className="iiconlist">
      {iconlist.map((listitem, index) => (
        <>
          {props.selected &&
            props.groupicons.indexOf(listitem.id + "") >= 0 && (
              <div key={"listitem" + index} className="iconbox">
                <div
                  className={"listitemselected"}
                  onClick={() => checkchange(listitem.id)}
                >
                  <Image blob={listitem.img} height={"30px"} width={"30px"} />
                  <Label label={listitem.caption} />
                </div>
              </div>
            )}

          {props.deselected &&
            props.groupicons.indexOf(listitem.id + "") < 0 && (
              <div key={"listitem" + index} className="iconbox">
                <div
                  className={"listitem"}
                  onClick={() => checkchange(listitem.id)}
                >
                  <Image blob={listitem.img} height={"40px"} width={"40px"} />
                  <Label label={listitem.caption} />
                </div>
              </div>
            )}

          {props.all && (
            <div key={"listitem" + index} className="iconbox">
              <div
                className={"listitem"}
                onClick={() => checkchange(listitem.id)}
              >
                <Image blob={listitem.img} height={"30px"} width={"30px"} />
                <Label label={listitem.caption} />
              </div>
              <div
                className="delete-icon"
                onClick={() => confirmDelete(listitem.id)}
              >
                <Trash2 size={20} />
              </div>
            </div>
          )}
        </>
      ))}

      {/* Confirmation Dialog */}
      {showConfirm && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h4>Delete Icon</h4>
            <p>Are you sure you want to delete this icon?</p>
            <div className="popup-buttons">
              <button
                className="btn btn-cancel"
                onClick={() => setShowConfirm(false)}
              >
                Cancel
              </button>
              <button className="btn btn-danger" onClick={handleDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      <Snackbar
            open={snackbar.open}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{vertical:"top", horizontal:"center" }}
            >
              <Alert
             onClose={handleCloseSnackbar}
             severity={snackbar.severity}
             variant="standard"
             sx={{width:"100%"}}
             >
              {snackbar.message}
              </Alert>
            </Snackbar>

      {errortext.length > 0 && <div className="errortext">{errortext}</div>}
    </div>
  );
};

export default Iconslist;
